__turbopack_context__.v({
  "container": "_2lkSrq_container",
  "root": "_2lkSrq_root",
});
